import { Link } from "react-router-dom";

export function Logo({ inverse = false }: { inverse?: boolean }) {
  return (
    <Link className={`logo ${inverse ? "logo--inverse" : ""}`} to="/" aria-label="ProstorAI početna">
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <g fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 43V5h38v11" />
          <path d="M13 37V25c0-2 1-3 3-3h16c2 0 3 1 3 3v12" />
          <path d="M13 30h22M18 22v15M30 22v15" />
        </g>
        <circle cx="38" cy="10" r="2.8" fill="var(--color-clay)" />
      </svg>
      <span>ProstorAI</span>
    </Link>
  );
}
